import script from "./UpgradeValueItem.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradeValueItem.vue?vue&type=script&setup=true&lang=js"

import "./UpgradeValueItem.vue?vue&type=style&index=0&id=c8ead5e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8ead5e0"]])

export default __exports__